import { Component } from 'react';

import { PatternMask } from '../masked';
import { MaskedInputProps } from '../maskedInput';

import { timeMatchableSymbols } from './constants';

export interface TimeMaskInputProps {
    timePattern: string;
    name: string;
}

export const timeMaskInputFactory = (MaskedInput: React.ComponentClass<MaskedInputProps>) => {
    class TimeMaskInput extends Component<TimeMaskInputProps> {
        private patternMask: PatternMask;
        private timePattern: string;

        constructor(props: TimeMaskInputProps) {
            super(props);
            this.patternMask = new PatternMask(props.timePattern, { matchableSymbols: timeMatchableSymbols });
            this.timePattern = props.timePattern;
        }

        render() {
            const { timePattern, ...other } = this.props;

            if (timePattern !== this.timePattern) {
                this.patternMask = new PatternMask(timePattern, { matchableSymbols: timeMatchableSymbols });
                this.timePattern = timePattern;
            }
            return <MaskedInput {...other} mask={this.patternMask} type="tel" />;
        }
    }

    return TimeMaskInput;
};

export default timeMaskInputFactory;
